/**
 * Utility functions for making authenticated API requests
 */

/**
 * Make an authenticated fetch request to the backend
 * @param {string} url - The API endpoint URL
 * @param {Object} options - Fetch options
 * @param {Object} userObj - Firebase user object with getIdToken method
 * @returns {Promise} - The fetch response
 */
export const authenticatedFetch = async (url, options = {}, userObj) => {
  try {
    const token = await userObj.getIdToken(true);
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    
    const mergedOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...(options.headers || {})
      }
    };
    
    const response = await fetch(url, mergedOptions);
    
    if (!response.ok) {
      let errorText;
      try {
        const errorData = await response.json();
        errorText = errorData.error || `HTTP error! status: ${response.status}`;
      } catch (e) {
        errorText = `HTTP error! status: ${response.status}`;
      }
      throw new Error(errorText);
    }
    
    return response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

/**
 * Make an authenticated form POST request to the backend
 * @param {string} url - The API endpoint URL
 * @param {FormData} formData - The form data to send
 * @param {Object} userObj - Firebase user object with getIdToken method
 * @returns {Promise} - The fetch response
 */
export const authenticatedFormPost = async (url, formData, userObj) => {
  try {
    const token = await userObj.getIdToken(true);
    
    const options = {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
        // Don't set Content-Type for FormData
      },
      body: formData
    };
    
    const response = await fetch(url, options);
    
    if (!response.ok) {
      let errorText;
      try {
        const errorData = await response.json();
        errorText = errorData.error || `HTTP error! status: ${response.status}`;
      } catch (e) {
        errorText = `HTTP error! status: ${response.status}`;
      }
      throw new Error(errorText);
    }
    
    return response.json();
  } catch (error) {
    console.error('API form post failed:', error);
    throw error;
  }
}; 